<template>
  <div class="project-vote-score">
    <el-popover
      placement="right"
      :visible-arrow="true"
      popper-class="project-vote-popover"
      trigger="hover"
      content="Vote for your favorite projects! The more compassSOL you stake, the bigger impact your votes have."
    >
      <template #reference>
        <div class="stake-score mb-3 text-center">
            🧭 Score: {{ formattedScore }}<br/>
            <button
                v-if="isAuthenticated"
                class="btn btn-outline-primary btn-sm small"
                @click="openVoteModal"
            >
                <el-icon><TakeawayBox/></el-icon> Vote
            </button>
            <a
                v-else
                href="/login"
                class="btn btn-outline-primary"
            >
                Login to Vote
            </a>
        </div>
      </template>
    </el-popover>



    <project-vote-modal
      v-if="isAuthenticated"
      :project="project"
      :is-modal-open="isModalOpen"
      ref="voteModal"
      @votes-updated="refreshScore"
    />
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import 'element-plus/theme-chalk/el-message.css'

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    isAuthenticated: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      score: this.project.stake_weighted_score || 0,
      voteCount: 0,
      modal: null,
      isModalOpen: false
    }
  },

  computed: {
    formattedScore() {
      return Number(this.score).toFixed(2)
    }
  },

  mounted() {
    if (this.isAuthenticated) {
      this.modal = new Modal(this.$refs.voteModal.$el)
    }
    this.fetchVoteCount()
    this.refreshScore()
  },

  methods: {
    openVoteModal() {
      this.isModalOpen = true
      this.modal.show()
    },

    async refreshScore() {
      if (this.isAuthenticated && this.modal) {
        this.isModalOpen = false
        this.modal.hide()
      }
      
      const checkScore = () => {
        const score = voteStore.getProjectScore(this.project.id)
        if (score !== undefined) {
          this.score = score
          this.fetchVoteCount()
        } else {
          setTimeout(checkScore, 100)
        }
      }
      
      checkScore()
    },

    async fetchVoteCount() {
      // await voteStore.loadAllVoteCounts()
      this.voteCount = voteStore.getProjectVoteCount(this.project.id)
    }
  }
}
</script>

<style>
.project-vote-popover {
  z-index: 2000;
}
</style>
